import { render, staticRenderFns } from "./Other-login.vue?vue&type=template&id=9b855c92&scoped=true"
import script from "./Other-login.vue?vue&type=script&lang=js"
export * from "./Other-login.vue?vue&type=script&lang=js"
import style0 from "./Other-login.vue?vue&type=style&index=0&id=9b855c92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b855c92",
  null
  
)

export default component.exports